var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareFacebook({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 45,
    y1: 89.46,
    x2: 45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0470e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14a0f8"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.12,78.52c2.4,0,4.61,11.3,6.91,10.93a45,45,0,1,0-14.06,0C40.29,89.82,42.7,78.52,45.12,78.52Z",
    fillRule: "evenodd",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.52,58l2-13H52V36.56c0-3.56,1.74-7,7.33-7H65V18.46A69.11,69.11,0,0,0,55,17.58c-10.28,0-17,6.23-17,17.51V45H26.54V58H38V89.45a45.2,45.2,0,0,0,14.06,0V58Z",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareFacebook);
export default __webpack_public_path__ + "static/media/share-facebook.9e13cccfa71e83cf5e3a32554ee6ec98.svg";
export { ForwardRef as ReactComponent };